import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import generatePDF from "react-to-pdf";
import { useLocation, useNavigate } from "react-router";
import ConfirmModal from "../modals/confirm-modal/ConfirmModal";
import PrintAddressModal from "./sub-components/print-address-modal/PrintAddressModal";
import PrintCard from "./sub-components/print-card/PrintCard";

const MultiPrint = () => {
  const printRef = useRef();

  const navigate = useNavigate();

  const [printData, setPrintData] = useState([]);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    contentRef: printRef,
    documentTitle: "print orders",
    bodyClass: "rtlDir",
    onAfterPrint: () => console.log("Printed PDF successfully!"),
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const location = useLocation();


  useEffect(() => {
    if (location?.state?.printData?.length) {
      setPrintData(location?.state?.printData);
    }
  }, [location?.state]);

  const confirmRef = useRef();
  const printAddressRef = useRef();

  const handleExport = () => {
    confirmRef.current.showModal();
  };
  const handlePrintAddress = () => {
    printAddressRef.current.showModal();
  };


  return (
    <>
      <ConfirmModal orderData={printData} ref={confirmRef} />
      <PrintAddressModal printData={printData} ref={printAddressRef} />
      {printData?.length ? (
        <div className="w-[1024px] mx-auto h-auto py-10 bg-white">
          <div className="flex items-center justify-between px-4">
            <div className="w-11/12 flex gap-3 items-center mx-auto">
              <button
                onClick={handlePrint}
                type="button"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                پرینت
              </button>
              <button
                onClick={handlePrintAddress}
                type="button"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                پرینت آدرس
              </button>
              <button
                onClick={handleExport}
                type="button"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                تایید سفارش
              </button>
              <button
                onClick={() => generatePDF(printRef, { filename: "page.pdf" })}
                type="button"
                className="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
              >
                دانلود PDF
              </button>
            </div>
            <p
              onClick={() => navigate(-1)}
              className="cursor-pointer focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
            >
              بازگشت
            </p>
          </div>
          <div ref={printRef} className="w-full p-4">
            {printData?.length
              ? printData.map((item) => {
                return <PrintCard data={item} />;
              })
              : null}
          </div>
        </div>
      ) : (
        <div className="w-11/12 mx-auto mt-8 py-12 flex flex-col gap-4 items-center justify-center bg-white shadow-lg rounded-xl">
          دیتایی وجود ندارد
          <p
            className="cursor-pointer text-blue-500"
            onClick={() => navigate(-1)}
          >
            بازگشت
          </p>
        </div>
      )}
    </>
  );
};
export default MultiPrint;
